import React from "react";
import PropTypes from "prop-types";

const ScoreDisplay = ({ score }) => {
  return (
    <div
      style={{
        backgroundColor: "#3498db",
        padding: "10px 20px",
        borderRadius: "20px",
        boxShadow: "0 2px 4px rgba(0, 0, 0, 0.2)",
        display: "inline-block",
      }}
    >
      <div style={{ textAlign: "center" }}>
        <div
          style={{
            color: "#fff",
            fontSize: "12px",
            fontWeight: "600",
            marginBottom: "2px",
          }}
        >
          Puntuación
        </div>
        <div
          style={{
            color: "#fff",
            fontSize: "24px",
            fontWeight: "bold",
          }}
        >
          {score}
        </div>
      </div>
    </div>
  );
};

ScoreDisplay.propTypes = {
  score: PropTypes.number.isRequired,
};

export default ScoreDisplay;
